import React from 'react';
import {
    SimpleGrid, FormControl, FormLabel, Select, Input, InputGroup, InputLeftAddon, InputRightAddon,
    ButtonGroup, Button, HStack,
} from '@chakra-ui/react';
import { CANAIS_CONTATO, mascaraTelefone } from './negociacao';

// Campos da negociacao (#1517). Controlado: quem usa guarda o estado.
const FormNegociacao = ({ valor, onChange, canalObrigatorio = false, isDisabled = false }) => {
    const set = (campo) => (e) => onChange({ ...valor, [campo]: e.target.value });

    return (
        <SimpleGrid columns={{ base: 1, sm: 2 }} spacing={3}>
            <FormControl isRequired={canalObrigatorio}>
                <FormLabel fontSize="sm" mb={1}>Canal de contato</FormLabel>
                <Select
                    size="sm"
                    borderRadius="md"
                    placeholder="Selecione"
                    value={valor.canal_contato}
                    onChange={set('canal_contato')}
                    isDisabled={isDisabled}
                    aria-label="Canal de contato"
                >
                    {CANAIS_CONTATO.map((c) => <option key={c.value} value={c.value}>{c.label}</option>)}
                </Select>
            </FormControl>

            <FormControl>
                <FormLabel fontSize="sm" mb={1}>Data da negociação</FormLabel>
                <Input size="sm" borderRadius="md" type="date" value={valor.data_negociacao} onChange={set('data_negociacao')} isDisabled={isDisabled} aria-label="Data da negociação" />
            </FormControl>

            {valor.canal_contato === 'outro' && (
                <FormControl isRequired gridColumn={{ sm: '1 / -1' }}>
                    <FormLabel fontSize="sm" mb={1}>Qual canal?</FormLabel>
                    <Input size="sm" borderRadius="md" maxLength={60} placeholder="Ex.: Instagram" value={valor.canal_contato_outro} onChange={set('canal_contato_outro')} isDisabled={isDisabled} aria-label="Qual canal" />
                </FormControl>
            )}

            <FormControl>
                <FormLabel fontSize="sm" mb={1}>Nome de quem negociou</FormLabel>
                <Input size="sm" borderRadius="md" maxLength={120} placeholder="Nome do cliente" value={valor.cliente_nome} onChange={set('cliente_nome')} isDisabled={isDisabled} aria-label="Nome de quem negociou" />
            </FormControl>

            <FormControl>
                <FormLabel fontSize="sm" mb={1}>Telefone</FormLabel>
                <Input
                    size="sm"
                    borderRadius="md"
                    inputMode="tel"
                    placeholder="(31) 99999-9999"
                    value={valor.cliente_telefone}
                    onChange={(e) => onChange({ ...valor, cliente_telefone: mascaraTelefone(e.target.value) })}
                    isDisabled={isDisabled}
                    aria-label="Telefone"
                />
            </FormControl>

            <FormControl>
                <FormLabel fontSize="sm" mb={1}>Cupom utilizado</FormLabel>
                <Input size="sm" borderRadius="md" maxLength={60} placeholder="Opcional" value={valor.cupom} onChange={set('cupom')} isDisabled={isDisabled} aria-label="Cupom utilizado" />
            </FormControl>

            <FormControl>
                <FormLabel fontSize="sm" mb={1}>Desconto concedido</FormLabel>
                <HStack spacing={2}>
                    <ButtonGroup size="sm" isAttached isDisabled={isDisabled}>
                        {[{ v: 'valor', l: 'R$' }, { v: 'percentual', l: '%' }].map((o) => (
                            <Button
                                key={o.v}
                                aria-pressed={valor.desconto_tipo === o.v}
                                aria-label={o.v === 'valor' ? 'Desconto em reais' : 'Desconto em percentual'}
                                colorScheme={valor.desconto_tipo === o.v ? 'orange' : 'gray'}
                                variant={valor.desconto_tipo === o.v ? 'solid' : 'outline'}
                                onClick={() => onChange({ ...valor, desconto_tipo: valor.desconto_tipo === o.v ? '' : o.v })}
                            >
                                {o.l}
                            </Button>
                        ))}
                    </ButtonGroup>
                    <InputGroup size="sm" flex="1" minW={0}>
                        {valor.desconto_tipo === 'valor' && <InputLeftAddon>R$</InputLeftAddon>}
                        <Input
                            borderRadius="md"
                            inputMode="decimal"
                            placeholder={valor.desconto_tipo === 'percentual' ? 'Ex.: 5' : '0,00'}
                            value={valor.desconto_valor}
                            onChange={(e) => onChange({ ...valor, desconto_valor: e.target.value.replace(/[^\d.,]/g, '') })}
                            isDisabled={isDisabled}
                            aria-label="Valor do desconto"
                        />
                        {valor.desconto_tipo === 'percentual' && <InputRightAddon>%</InputRightAddon>}
                    </InputGroup>
                </HStack>
            </FormControl>
        </SimpleGrid>
    );
};

export default FormNegociacao;
